export default __webpack_public_path__ + "static/vino2-37fb7fef8be6d4d769b20b4a0d5142fc.jpg";